import React from "react";

import { twJoin } from "tailwind-merge";

import { CopyTextIcon } from "src/base-components/CopyTextIcon";

export type ErrorBlobVariant = "error" | "warning";

type ErrorBlobDisplayProps = {
  title: string;
  errorBlob: string;
  isCodeBlock: boolean;
  dataLoc?: string;
  variant?: ErrorBlobVariant;
};

const VARIANT_CLASSES = {
  error: "border-red-200 bg-red-50",
  warning: "border-orange-200 bg-orange-50",
} as const;

export const ErrorBlobDisplay: React.FC<ErrorBlobDisplayProps> = ({
  title,
  errorBlob,
  isCodeBlock,
  dataLoc,
  variant = "error",
}) => {
  if (!isCodeBlock) {
    return (
      <div data-loc={dataLoc}>
        {title} {errorBlob}
      </div>
    );
  }

  return (
    <div data-loc={dataLoc}>
      <div className="mb-2">{title}</div>
      <div
        className={twJoin(
          "relative mr-2 rounded-lg border p-3 font-code-12",
          VARIANT_CLASSES[variant],
        )}
      >
        <div className="whitespace-pre-wrap pr-8">{errorBlob}</div>
        <div className="absolute top-3 right-3">
          <CopyTextIcon
            size="xs"
            tooltip="Copy"
            value={errorBlob}
            variant={variant}
          />
        </div>
      </div>
    </div>
  );
};
